import { Customer, api } from "./customers";

export interface DashboardCustomersResponse {
  status: string;
  message: string;
  total_count: number;
  total_pages: number;
  current_page: number;
  data: Customer[];
  per_page: number;
  prev_page: number;
  nextPage: number;
}
export interface AppinmentById {
  status: string;
  message: string;
  data: Customer[];
}
type DasboardCustomersResponse = DashboardCustomersResponse[];
type AppoinmentByidResponse = AppinmentById[];

export const ReportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getReportsList: build.query<any, any>({
      query: (type) => `reports?thisMonth=${type}`,
    }),

    // Get Doctor List
    getDoctorList: build.query<any, void>({
      query: () => `consultant_reports`,
    }),

    // Export report with params
    // Export report with params
    getNewReportinExcel: build.mutation<
      any,
      {
        startDate: string;
        endDate: string;
        consultantId: string;
        status?: string;
      }
    >({
      query: ({ startDate, endDate, consultantId, status }) => {
        const params = new URLSearchParams({
          start_date: startDate || "",
          end_date: endDate || "",
          consultantId: consultantId || "",
        });

        // ✅ Only include status if it's selected
        if (status) params.append("status", status);

        return {
          url: `new_report_exports?${params.toString()}`,
          method: "GET",
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    // getReportinExcel: build.mutation<AppoinmentByidResponse, any>({
    //   query: () => `report_exports`,
    //   providesTags: ["Reports"],
    //   transformResponse: (
    //     response: { data: AppoinmentByidResponse },
    //     meta,
    //     arg
    //   ) => response.data,
    // }),
    getReportinExcel: build.mutation<any, Partial<void>>({
      query: () => ({
        url: `report_exports`,
        method: "get",
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
      invalidatesTags: [{ type: "Reports", id: "LIST" }],
    }),
  }),
});
export const {
  useGetReportsListQuery,
  useGetReportinExcelMutation,
  useGetDoctorListQuery,
  useGetNewReportinExcelMutation,
} = ReportsApi;
